import React, { useState, useEffect } from "react";
import { Form, Select, Switch } from "antd";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { elvis } from "../../Utils";
import Map2 from "../Map/Map2";

const { Option } = Select;

const ElectricalInfrastructureDamageForm = props => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [categoryTypes, setCategoryTypes] = useState([]);

    useEffect(() => {
        axios
            .get(process.env.REACT_APP_API_ENDPOINT + "/electrical/enums/damage-categories")
            .then(({ data }) => {
                setCategoryTypes(data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        if (props.record.damage) {
            form.setFieldsValue({
                damageCategory: props.record.damage.damageCategory,
                reachable: props.record.damage.reachable,
                geometry: props.record.damage.geometry,
            });
        }
    }, [props.record.damage, form]);

    // Handle form field changes
    const onValuesChange = (changedValues, allValues) => {
        const newDamage = { ...props.record };
        newDamage.damage.damageCategory = elvis(allValues.damageCategory);
        newDamage.damage.reachable = elvis(allValues.reachable);
        newDamage.damage.geometry = elvis(allValues.geometry);
        newDamage.damage.damageClass = props.damageClass;
        
        // Check if form is valid
        form.validateFields()
            .then(() => {
                newDamage.valid = true;
                props.parentCallback(newDamage);
            })
            .catch(() => {
                newDamage.valid = false;
                props.parentCallback(newDamage);
            });
    };

    return (
        <Form 
            form={form}
            layout="horizontal"
            onValuesChange={onValuesChange}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            name="infrastructureDamageForm"
        >
            <Form.Item label="Category" name="damageCategory">
                <Select>
                    {categoryTypes.map(name => (
                        <Option key={name} value={name}>
                            {t('electricalEnums.damageCategory.' + name, name)}
                        </Option>
                    ))}
                </Select>
            </Form.Item>
            <Form.Item label="Reachable" name="reachable" valuePropName="checked">
                <Switch />
            </Form.Item>
            <Form.Item label="Affected Area" name="geometry">
                <Map2 name="area" />
            </Form.Item>
        </Form>
    );
};

export default ElectricalInfrastructureDamageForm;